import React, { ReactNode } from "react";
import styles from "./styles";

export interface Emotion {
  id: string;
  label: string;
  description: string;
  Icon?: React.FC;
}

export interface EmotionCardProps {
  emotion: Emotion;
  isSelected: boolean;
  setSelectedEmotion: (id: string) => void;
}

const EmotionCard: React.FC<EmotionCardProps> = ({
  emotion,
  isSelected,
  setSelectedEmotion,
}) => {
  const handleSelect = (id: string) => {
    setSelectedEmotion(id);
  };

  return (
    <button
      key={emotion.id}
      style={{
        ...styles.emotionItem,
        ...(isSelected && styles.emotionItemSelected),
      }}
      onClick={() => handleSelect(emotion.id)}
      // activeOpacity={0.8}
    >
      <div style={styles.iconContainer}>
        {emotion.Icon && (emotion.Icon({}) as ReactNode)}
      </div>
      <div style={styles.textContainer}>
        <h2
          style={{
            ...styles.emotionLabel,
            ...(isSelected && styles.emotionLabelSelected),
          }}
        >
          {emotion.label}
        </h2>
        <h2
          style={{
            ...styles.emotionDescription,
            ...(isSelected && styles.emotionDescriptionSelected),
          }}
        >
          {emotion.description}
        </h2>
      </div>
    </button>
  );
};

export default EmotionCard;
